import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 样式
import '@/styles/index.scss'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 工具
import * as utils from '@/utils'

// API服务
import * as api from '@/api'

// ECharts
import VChart from 'vue-echarts'

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册ECharts组件
app.component('VChart', VChart)

// 使用插件
app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})

// 全局属性
app.config.globalProperties.$utils = utils
app.config.globalProperties.$api = api

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('全局错误:', err, info)
}

// 进度条路由守卫
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

// 应用启动时恢复登录状态
async function initApp() {
  console.log('初始化管理后台应用')

  // 恢复登录状态
  await store.dispatch('restoreAuth')

  // 挂载应用
  app.mount('#app')

  console.log('虚拟换衣管理后台启动成功！')
}

// 启动应用
initApp()
